import { render } from "./DragonCards.vue?vue&type=template&id=3b396a5e&scoped=true&ts=true"
import script from "./DragonCards.vue?vue&type=script&lang=ts"
export * from "./DragonCards.vue?vue&type=script&lang=ts"

import "./DragonCards.vue?vue&type=style&index=0&id=3b396a5e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b396a5e"]])

export default __exports__